module.exports = __webpack_public_path__ + "media/images/dashboard_icons/ic_profit-5dcd4e0e49ca51d2aca872cf66e98c20.svg";